import {ExtendedStatisticsCar} from '../types/ExtendedStatisticsCar';

export function isVehicleMatchingSelectedSeller(
  car: ExtendedStatisticsCar,
  selectedSellerId: string | null
) {
  if (!selectedSellerId) {
    return false;
  }

  return car.seller?.id === selectedSellerId;
}
